<template>
    <div>
        <page-header :title="title" :items="items" />

        <div class="card">
            <div class="card-body">
                <div class="mb-2">
                    <button
                        class="btn btn-success waves-effect waves-light"
                        @click="showAddModal"
                    >
                        <i class="fas fa-plus-circle" />
                        Add Media
                    </button>
                </div>
                <preview
                    :key="mediaKey"
                    is-deletable
                    @on-select-media="selectMedia"
                    @on-delete-media="showDeleteModal"
                />
            </div>
        </div>

        <create-edit-modal
            :media-to-edit="mediaToEdit"
            @hide="mediaToEdit = null"
            @fetch-media="fetchMedia"
            @updated="onMediaUpdated"
        />

        <confirmation-modal
            :title="'Do you want to delete this media?'"
            @agree="removeMedia"
            @disagree="idToDelete = null"
        />
    </div>
</template>

<script>
import { StatusCodes as HTTP } from 'http-status-codes';
import { mapActions } from 'vuex';
import Preview from '@/components/media/Preview';
import ConfirmationModal from '@/components/elements/ConfirmationModal';
import CreateEditModal from '@/components/media/CreateEditModal';

export default {
    page: {
        title: 'Media'
    },

    components: {
        CreateEditModal,
        ConfirmationModal,
        Preview
    },

    data() {
        return {
            title: 'Media',
            items: [
                {
                    text: 'Aguda',
                    to: '/'
                },
                {
                    text: 'Media',
                    active: true
                }
            ],
            mediaToEdit: null,
            mediaKey: 0,
            idToDelete: null,
            updateTime: 0
        };
    },

    methods: {
        ...mapActions({
            deleteMedia: 'media/delete'
        }),

        fetchMedia() {
            this.mediaKey++;
        },

        showAddModal() {
            this.$bvModal.show('modal-create-edit');
        },

        selectMedia(media) {
            this.mediaToEdit = media[0];
            this.$bvModal.show('modal-create-edit');
        },

        showDeleteModal(id) {
            this.idToDelete = id;
            this.$bvModal.show('confirm-modal');
        },

        async removeMedia() {
            try {
                await this.deleteMedia(this.idToDelete);

                this.idToDelete = null;
                this.fetchMedia();

                this.$toaster('Media has been deleted!');
            } catch (error) {
                const { response } = error;

                if (response) {
                    const { data, status } = response;

                    if (status === HTTP.UNPROCESSABLE_ENTITY && data) {
                        this.$toasterError(data);

                        return;
                    }
                }

                console.error(error);

                this.$toasterError();
            }
        },

        onMediaUpdated(media) {
            this.mediaToEdit = { ...media };
            this.mediaKey++;
        }
    }
};
</script>
